<template>
  <div class="logMgt" style="padding: 0 1em;">
    <b-tabs content-class="mt-3"
      active-nav-item-class="font-weight-bold text-uppercase text-danger"
      active-tab-class="font-weight-bold text-success">
        <b-tab name="first" active>
          <template #title>
            <b-icon icon="list-task"/>列表
          </template>
          <table cellpadding="0" cellspacing="0" class="ncut-table-search" style="width: 99%;">
              <tbody>
                <tr>
                  <td class="ncut-base-form-text" style="width:3em;">查詢&nbsp;&nbsp;&nbsp;<br/>日期：</td>
                  <td class="ncut-base-form-ipt" style="width:21em;">
                    <b-input-group>
                      <b-form-datepicker v-model="queryInfo.sDate" :max="queryInfo.eDate" locale="zh-TW"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" required></b-form-datepicker>&nbsp;<span style="padding: 0.425rem 0 0;">至</span>&nbsp;
                      <b-form-datepicker v-model="queryInfo.eDate" :min="queryInfo.sDate" locale="zh-TW"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" required></b-form-datepicker>
                    </b-input-group>
                  </td>
                  <td class="ncut-base-form-text" style="width:4rem;">類別：</td>
                  <td class="ncut-base-form-ipt" style="width:7rem;">
                    <b-form-select label-for="input-1" style="padding: 0.375rem 0.75rem; border: 1px solid #ced4da; border-radius: 0.25rem;"
                      v-model="queryInfo.mode"
                      placeholder="請選擇類別"
                      required>
                      <b-form-select-option v-for="item in typeList0"
                        :key="'K'+item.id"
                        :value="item.id">{{item.text2}}</b-form-select-option>
                      <b-form-select-option
                        key="K0" :value="0">全部</b-form-select-option>
                    </b-form-select>
                  </td>
                  <td style="padding: 0.25rem 0.25rem; text-align: left;">
                      <b-button variant="outline-primary"
                          @click="query()"><b-icon icon="search"/>{{$t('message.Query_cmd')}}</b-button>&nbsp;&nbsp;
                      <span class="pull-right" style="padding: 0.4rem;"
                        v-show="0<totalItems">
                        <span style="margin-right: 4px; background: #ffcdcd; font-weight: bolder;">筆數：</span><span>{{totalItems}}</span>
                      </span>
                  </td>
                </tr>
              </tbody>
          </table>
          <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF" style="margin:0;">
                <thead class="ncut-thead-menu">
                  <tr>
                    <th class="list-td" style="min-width: 2.5rem;">序號</th>
                    <th class="list-td" style="min-width: 7rem;">類別</th>
                    <th class="list-td" style="min-width: 3.5rem;">方法</th>
                    <th class="list-td" style="min-width: 5rem;">IP</th>
                    <th class="list-td">參數</th>
                    <th class="list-td" style="min-width: 7.5rem;">執行時間</th>
                  </tr>
                </thead>
                <tbody class="ncut-tbody-menu" style="text-align: left;">
                  <tr v-for="(item, index) in filteredCars" :key="'T1'+item.lId" :index="item.lId" :name="item.lId">
                    <td class="list-td" style="text-align: center;">{{(currentPage-1)*pageSize+index+1}}</td>
                    <td class="list-td">{{getTypeName(item.type)}}</td>
                    <td class="list-td">{{item.method}}</td>
                    <td class="list-td" style="font-size: smaller;">{{item.ip}}</td>
                    <td class="list-td" style="font-size: smaller;">{{item.content}}</td>
                    <td class="list-td" style="font-size: smaller;">{{item.createTime | dateFormatV2}}</td>
                  </tr>
                  <tr>
                    <td colspan="6" v-show="0==totalItems">無相關處理日誌!</td>
                  </tr>
                </tbody>
            </table>
          </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="curItems"
            :per-page="pageSize"
            v-if="totalItems>pageSize" />
        </b-tab>
        <!-- <b-tab name="second">
          <template #title>
            <b-icon icon="tools"/>參數維護
          </template>
          <div class="well">
            <div style="background-color: #FAFBFC; text-align: left;">
              <div class="ncut-base-form-button" style="padding: 1rem; text-align: left;">
                <b-button variant="success" @click="save()"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
                <table>
                  <tr style="line-height: 3;"
                    v-for="item in typeList0" :key="'T2'+item.id" :index="item.id" :name="item.id">
                    <td style="color:#f86b1d;"><i class="el-icon-collection-tag"/></td>
                    <td class="td_text" style="width:9rem;">{{item.text2}}</td>
                    <td class="td_text" style="width:6rem;">
                      <b-form-radio v-model="item.statusId" name="some-radios" :value="0">不保留</b-form-radio>
                    </td>
                    <td class="td_text" style="width:6rem;">
                      <b-form-radio v-model="item.statusId" name="some-radios" :value="1">保留</b-form-radio>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </b-tab> -->
    </b-tabs>
  </div>
</template>

<script>

import * as tools from '@/tool';
export default {
    name: 'logMgt',
    data () {
        return {
          queryInfo: {
            sysId: 0,
            sDate: null,
            eDate: null,
            status:0,
            mode: 0
          },
          totalItems: 0,
          curItems: 0,
          currentPage: 1,
          pageSize: 20,
          docRecordList: null,
          typeList0: null,
          sData: null
        }
    },
    computed: {
      sysId () {
        return this.$store.getters.getSysId
      },
      user () {
        return this.$store.getters
      },
      pickerOpt() {
        return tools.pickerOptions2;
      },
      filteredCars: function(){
        var cars = [];
        if (!tools.isNull(this.docRecordList)) {
          if(this.queryInfo.mode == 0){
            cars = this.docRecordList
          }
          else
          {
            cars = this.docRecordList.filter(car => {
              return this.queryInfo.mode == car.type
            })
          }
          this.curItems = cars.length;
          cars = cars.slice((this.currentPage-1)*this.pageSize, this.currentPage*this.pageSize)

        }
        return cars;
      }
    },
    filters: {
        dateFormatV2:function(input) {
        var d = new Date(input);
        var year = d.getFullYear();
        var month = d.getMonth() + 1;
        var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
        var hh = d.getHours();
        var mm = d.getMinutes();
        var ss = d.getSeconds();
        return  tools.stringFormat("{0}年 {1}月 {2}日 {3}時 {4}分 {5}秒", year, month, day, hh, mm, ss);
        }
    },
    methods: {
      getTypeName (id) {
        var ret = '';
        var tLen = this.typeList0.length;
        for (var i = 0; i < tLen ; i++) {
          if (this.typeList0[i].id == id) {
            ret = this.typeList0[i].text2
          }
        }
        return ret;
      },
      checkQueryData () {
        let msg = '';
        if (tools.isNull(this.queryInfo.sDate)) {
          msg = '啟始日期';
        } else if (tools.isNull(this.queryInfo.eDate)) {
          msg = '終止日期';
        }

        return msg;
      },
      query () {
        var msg = this.checkQueryData();
        if (0 == msg.length) {
          let vm = this;
          this.docRecordList = null;
          this.totalItems = 0;
          this.$http.put('./WebApi/Setting/GetLogData', this.queryInfo)
            .then((response) => {
              if (!tools.isNull(response)) {
                vm.docRecordList = response.data;
                vm.totalItems = vm.docRecordList.length;
              }
              vm.currentPage = 1;
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error);
          })
        } else {
          tools.showAlert(vm, 'danger', '對不起,請輸入' + msg);
        }
      },
      getTypeSet: function (type) {
        return this.$http
                  .get('./WebApi/Common/GetCodeNameToInt/'.concat(this.sysId).concat("/").concat(type).concat("/2"));
      },
      save () {
        if (!tools.isNull(this.typeList0)) {
          var vm = this;
          var lLen = this.typeList0.length;
          var data = 0;
          for (var i = 0; i < lLen; i++) {
            if (0 < this.typeList0[i].statusId) {
               data |=  Math.pow(2,this.typeList0[i].id);
            }
          }
          this.$http.get('./WebApi/Setting/SetLogSet/'.concat(this.sysId).concat("/").concat(data))
              .then((response) => {
                if (response.data) {
                  tools.showAlert(vm, 'success', '恭喜您,存檔成功');
                }
                else {
                  tools.showAlert(vm, 'danger', '存檔失敗');
                }
              })
              .catch(function (error) {
                tools.showAlert(vm, 'danger', '存檔失敗');
              })
        }
      },
      getLogSet () {
        let vm = this;
        this.$http.get('./WebApi/Common/GetCodeNameToInt/'.concat(this.sysId).concat("/LogType"))
                  .then((response) => {
                    if (!tools.isNull(response.data)) {
                      var sData = parseInt(response.data[0].text2);
                      var lLen = vm.typeList0.length;
                      for (var i = 0; i < lLen; i++) {
                          vm.typeList0[i].statusId = (sData & Math.pow(2,vm.typeList0[i].id)) >> vm.typeList0[i].id;
                      }
                    }
                  })
                  .catch(function (error) {
                    tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error);
                  })
      }
    },
    created () {
      //console.log('== LogView ==');
      let vm = this;
      var today = new Date();
      var yy = today.getFullYear();
      this.queryInfo.sysId = this.sysId;
      this.queryInfo.sDate = tools.setDate(yy, 0, 1);
      this.queryInfo.eDate = tools.setDate(yy, 11, 31);
      this.$http.all([this.getTypeSet('LogType')])
                .then(vm.$http.spread(function (data0) {
                      if (!tools.isNull(data0)) {
                        vm.typeList0 = data0.data;
                        vm.getLogSet();
                      }
                }))
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.td_text {
  border-bottom: 1px solid #9abeaf;
}
</style>
